import { apiClient } from '../../../../core/api/client';

/**
 * Provider dashboard statistics type
 */
export type ProviderStats = {
  profileViews: number;
  newLeads: number;
  unreadMessages: number;
  rating: number;
  reviewCount: number;
};

/**
 * Fetch provider dashboard statistics
 * Returns metrics for dashboard display
 * 
 * @returns Promise<ProviderStats> Dashboard statistics
 * @throws Error if request fails or user is not authenticated
 */
export async function fetchProviderStats(): Promise<ProviderStats> {
  const response = await apiClient.get<ProviderStats>(
    '/service-providers/profile/statistics'
  );
  
  return response.data;
}

